module.exports = __webpack_public_path__ + "img/achkar.b5b4a897.jpeg";